<template>
  <div class="page h-screen flex flex-col">
    <div class="flex-1 flex flex-col justify-end overflow-auto">
      <FormPage 
        name="suitability"/>
    </div>
  </div>
</template>

<script>
import FormPage from "@/components/general/FormPage";
import form from "@/assets/ts/suitability/base";
import { defineComponent } from "vue";
import store from '@/store/index'
export default defineComponent({
  components: {
    FormPage
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      store.dispatch('setForm', form)
    });
  },
  setup(){
  }
})

</script>
